import BaseComponent from "../../baseComponent.js";

export default class YearPicker extends BaseComponent {
  constructor(props) {
    super(props);
  }

  componentDidMount() {
    $(this.refs.container).find("select").material_select();
  }

  render() {
    return (
      <div ref="container">
        <select className="profile-filters__year" defaultValue={this.props.year}>
          <option value={this.props.year}>{this.props.year}</option>
        </select>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/profile/common/yearPicker.jsx